import { Spinner as BPSpinner, SpinnerProps } from '@blueprintjs/core';
import React from 'react';

const CastedBPSpinner = BPSpinner as React.ComponentType<SpinnerProps>;

const Spinner = (props: SpinnerProps) => {
    // @ts-ignore
    return <CastedBPSpinner {...props} />;
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.tsx